var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2609232"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2609233"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 62",
    cx: 11.5,
    cy: 11,
    r: 10.5,
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.3499 11.0001C21.3499 12.7032 20.9185 14.3055 20.1557 15.7023L14.1313 12.2236L14.1313 12.2236L14.0965 12.2036C14.2663 11.8366 14.3627 11.4287 14.3627 11.0001C14.3627 10.6268 14.2907 10.2713 14.1612 9.94546V9.94218L14.1501 9.91497C14.1334 9.87397 14.1159 9.8335 14.0972 9.79326L20.1556 6.29505C20.9185 7.69472 21.3499 9.29709 21.3499 11.0001Z",
    fill: "#9AB740",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.90155 12.2029L2.84419 15.7022C2.0814 14.3054 1.65 12.7031 1.65 11.0001C1.65 9.29703 2.0814 7.69474 2.84421 6.29792L8.90339 9.79659C8.73358 10.1636 8.63721 10.5719 8.63721 11.0031C8.63721 11.4295 8.73013 11.8353 8.90155 12.2029Z",
    fill: "#777777",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.7552 8.14917V1.15265C15.2042 1.23916 18.2109 3.09879 19.903 5.8548L13.8414 9.35321C13.3694 8.68281 12.616 8.22382 11.7552 8.14917Z",
    fill: "#D72630",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.15869 9.35034L3.09982 5.85472C4.7891 3.09886 7.79848 1.23921 11.2447 1.15265V8.14655C10.3817 8.22351 9.63053 8.6824 9.15869 9.35034Z",
    fill: "#0C54B6",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M3.0998 16.1459L9.15928 12.6486C9.6311 13.3184 10.3819 13.777 11.2447 13.8515V20.848C7.79569 20.7615 4.78903 18.9018 3.0998 16.1459Z",
    fill: "#CC2692",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M13.8847 12.6732L13.8851 12.6734L19.903 16.1458C18.2109 18.9019 15.2042 20.7615 11.7552 20.848V13.8511C12.6179 13.7744 13.3691 13.3181 13.8412 12.6478L13.8847 12.6732Z",
    fill: "#EDC600",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 62_2",
    cx: 11.5,
    cy: 11,
    r: 10.5,
    stroke: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorIcon);
export default __webpack_public_path__ + "static/media/color-icon.5acdba07cdfc29773acb3ad561186452.svg";
export { ForwardRef as ReactComponent };